import { useEffect, useState } from "react";
import { findAllCollaborators } from "../../../../API/apiCollaborators";
import { 
  activateUser, 
  inactivateUser, 
  inactivateUsers, 
  activateUsers,
  sendTemporaryPassword,
  newpasswordUsers, 
} from "../../../../API/fetchUsuarios";

import { CollaboratorType } from "../../../../types/Collaborator";
import { PaginationType } from "../../../../types/Pagination";

import { exportPDF } from "utils/exporters/exportPDF";
import { exportXLSX } from "utils/exporters/exportXLSX";
import { ExportColumn } from "types/ExportTypes";

export const useCollaborator = () => {

  const [msgError, setMsgError ] = useState<string | null>(null);
  const [msgSuccess, setMsgSuccess ] = useState<string | null>(null);
  const [loading, setLoading] = useState< boolean>(false);
  const [loadingExport, setLoadingExport] = useState< boolean>(false);
  const [loadingConfirm, setLoadingConfirm] = useState< boolean>(false);
  const [collaborators, setCollaborators] = useState<CollaboratorType[]>([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pagination, setPagination] = useState<PaginationType | null>(null);

  const [searchCpf, setSearchCpf] = useState<string>("");
  const [searchNome, setSearchNome] = useState<string>(""); 
  const [searchEmail, setSearchEmail] = useState<string>(""); 
  const [searchInstitution, setSearcInstitution] = useState<number | null>(null); 
  const [searchStatus, setSearchStatus] = useState<number | undefined>(undefined);

  const [openExportPdf, setOpenExportPdf] = useState<boolean>(false);
  const [openExportXls, setOpenExportXls] = useState<boolean>(false);

  useEffect(() => {
    buscarColaboradores(1, 10);
  }, []);

  useEffect(() => {
  
    buscarColaboradores(currentPage, perPage);
  }, [
    currentPage,
    perPage,
  ]);

  useEffect(() => {
    if (msgSuccess) {
      setTimeout(() => {
        setMsgSuccess(null);
      }, 5000);
    }
  }, [msgSuccess]);

  useEffect(() => {
    if (msgError) {
      setTimeout(() => {
        setMsgError(null);
      }, 5000);
    }
  }, [msgError]);

  useEffect(() => {
    if (msgError) {
      setTimeout(() => {
        setMsgError(null);
      }, 5000);
    }
  }, [msgError]);

  const buscarColaboradores = async (
    currentPage: number,
    perPage: number,
    searchNome?: string,
    searchCpf?: string,
    searchEmail?: string,
    searchInstitution?: number | null,
    searchStatus?: number,
  ) => {

    setLoading(true);

    try {

      const result = await findAllCollaborators(currentPage, perPage, searchNome, searchCpf, searchEmail, searchInstitution, searchStatus);

      setCollaborators(result.collaborators);

      if (result.pagination) {
        setTotalPages(Math.ceil(result.pagination.total / perPage));
      }

      setPagination(result.pagination);
      setLoading(false);

    } catch (error) {

      setMsgError('Erro ao listar os colaboradores');
    }
  };

  const recarregarColaboradores = () => {
    buscarColaboradores(currentPage, perPage);
  };

  const filterColaboradores =  () => {
    buscarColaboradores(currentPage, perPage, searchNome, searchCpf, searchEmail, searchInstitution, searchStatus);
  };

  const hesetFilter = () => {
    setSearchCpf("");
    setSearchNome("");
    setSearchEmail("");
    setSearcInstitution(null);
    setSearchStatus(undefined);
    buscarColaboradores(currentPage, perPage);
  };

  const inactivateCollaborator = async (id: number | null | undefined) => {

    if (!id) {
      throw('Colaborador não encontrado');
    }
    setLoadingConfirm(true);
    await inactivateUser(id);
    setLoadingConfirm(false);
    return;
  };

  const activateCollaborator = async (id: number | null | undefined) => {

    if (!id) {
      throw('Colaborador não encontrado');
    }

    setLoadingConfirm(true);
    await activateUser(id);
    setLoadingConfirm(false);
    return;
  };

  const newPasswordCollaborator = async (id: number | null | undefined) => {

    if (!id) {
      throw('Colaborador não encontrado');
    }

    setLoadingConfirm(true);
    await sendTemporaryPassword(id);
    setLoadingConfirm(false);
    return;
  };

  const inactivateMultipleCollaborators = async (ids: number[]) => {
    
    if (ids.length === 0) {
      throw('Nenhum colaborador selecionado');
    }
    
    setLoadingConfirm(true);
    await inactivateUsers(ids);
    setLoadingConfirm(false);
    return;
  };

  const activateMultipleCollaborators = async (ids: number[]) => {
    
    if (ids.length === 0) {
      throw('Nenhum colaborador selecionado');
    }
    
    setLoadingConfirm(true);
    await activateUsers(ids);
    setLoadingConfirm(false);
    return;
  };

  const newPasswordMultipleCollaborators = async (ids: number[]) => {
    
    if (ids.length === 0) {
      throw('Nenhum colaborador selecionado');
    }
    
    setLoadingConfirm(true);
    await newpasswordUsers(ids);
    setLoadingConfirm(false);
    return;
  };

  const handleExportPdf = async () => {
  
    try {

      setLoadingExport(true);

      const result = await findAllCollaborators(1, 999999, searchNome, searchCpf, searchEmail, searchInstitution);

      const data = result.collaborators;

      if (!data) {
        setLoadingExport(false);
        setOpenExportPdf(false);
        setMsgError('Não existem dados para serem exportados!');
        return;
      }

      const columns: ExportColumn[] = [
        { label: "Nome", key: "nome" },
        { label: "CPF", key: "cpf" },
        { label: "E-mail", key: "email" },
        { label: "Instituição Vinculada", key: "instituicao_vinculada" },
        { label: "Status", key: "ativo" },
      ];

      const mappedData = data.map((item) => ({
        ...item,
        instituicao_vinculada: item.instituicoes?.[0]?.nome || "Sem Instituição Vinculada",
      }));

      exportPDF(columns, mappedData, "usuarios.pdf");

      setLoadingExport(false);
      setOpenExportPdf(false);

    } catch (error) {

      setLoadingExport(false);
      setMsgError('Não foi possível gerar o PDF!');
    }
  };

  const handleExportXls = async () => {

    try {

      setLoadingExport(true);

      const result = await findAllCollaborators(1, 999999, searchNome, searchCpf, searchEmail, searchInstitution);

      const data = result.collaborators;

      if (!data) {
        setLoadingExport(false);
        setOpenExportPdf(false);
        setMsgError('Não existem dados para serem exportados!');
        return;
      }

      const columns: ExportColumn[] = [
        { label: "Nome", key: "nome" },
        { label: "CPF", key: "cpf" },
        { label: "E-mail", key: "email" },
        { label: "Instituição Vinculada", key: "instituicao_vinculada" },
        { label: "Status", key: "ativo" },
      ];

      const mappedData = data.map((item) => ({
        ...item,
        instituicao_vinculada: item.instituicoes?.[0]?.nome || "Sem Instituição Vinculada",
      }));

      exportXLSX(columns, mappedData, "usuarios.xlsx");

      setLoadingExport(false);
      setOpenExportXls(false);

    } catch (error) {

      setLoadingExport(false);
      setMsgError('Não foi possível gerar o XLS!');
    }
  };

  return {
    msgError,
    msgSuccess,
    loading,
    loadingExport,
    loadingConfirm,
    collaborators,
    pagination,
    currentPage,
    perPage,
    totalPages,
    searchCpf,
    setSearchCpf,
    searchNome,
    setSearchNome,
    searchEmail,
    setSearchEmail,
    searchInstitution,
    setSearcInstitution,
    searchStatus,
    setSearchStatus,
    openExportPdf,
    setOpenExportPdf,
    openExportXls,
    setOpenExportXls,
    setMsgError,
    setMsgSuccess,
    setCurrentPage,
    setPerPage,
    buscarColaboradores,
    inactivateCollaborator,
    activateCollaborator,
    newPasswordCollaborator,
    recarregarColaboradores,
    inactivateMultipleCollaborators,
    activateMultipleCollaborators,
    newPasswordMultipleCollaborators,
    filterColaboradores,
    hesetFilter,
    handleExportPdf,
    handleExportXls,
  };

};
